import React, {forwardRef, useEffect, useImperativeHandle, useRef, useState} from "react";
import useMediaQuery from "../hooks/useMediaQuery";
import Loader from "./Loader";
import {getHashOfItems} from "../items";

const CharacterViewer = ({ height, width, spec }) => {
    const [isLoaded, setIsLoaded] = useState(false);
    const [unityInitialized, setUnityInitialized] = useState(false);
    const canvasRef = useRef(null);
    const initializedRef = useRef(false);
    const displayedSpec = useRef(spec);
    const isMobile = useMediaQuery({ maxWidth: 768 });

    useEffect(() => {
        const canvas = canvasRef.current;
        let directory = isMobile ? 'character-viewer/mobile' : 'character-viewer';
        directory = 'character-viewer/mobile'; // Force mobile for now

        console.log('INITIALIZING UNITY using directory: ', directory);

        const origin = window.location.origin;
        console.log('origin', origin);
        const initializeUnity = () => {
            window.onUnityLoaded = () => {
                setIsLoaded(true);
                setUnityInitialized(true);
            };
            const hash = getHashOfItems();
            window.createUnityInstance(canvas, {
                dataUrl: `${origin}/${directory}/ViewerExample.data?hash=${hash}`,
                frameworkUrl: `${origin}/${directory}/ViewerExample.framework.js?hash=${hash}`,
                codeUrl: `${origin}/${directory}/ViewerExample.wasm?hash=${hash}`,
                streamingAssetsUrl: "StreamingAssets",
                companyName: "GroveWars, Inc.",
                productName: "GroveWars Warrior",
                productVersion: "0.1",
            }).then((instance) => {
                window.unity = instance;
            });
        };

        if (!initializedRef.current) {
            initializedRef.current = true;
            initializeUnity();
        }

        return () => {
            if (window.unity) {
                console.log('Unloading Unity instance');
                window.unity.Quit().then(() => {
                    window.unity = null;
                    window.onUnityLoaded = null;
                    console.log('Unity instance unloaded and cleaned up');
                });
            }
        };
    }, [isMobile]);

    useEffect(() => {
        if (isLoaded && unityInitialized) {
            console.log('[RELOAD_CHARACTER_SPEC] spec == ', spec);
            const { character, weapon, back_swag, emote } = spec;

            window.unity.SendMessage('JsBridge', 'SetCharacter', character);
            window.unity.SendMessage('JsBridge', 'SetBackpack', back_swag);
            window.unity.SendMessage('JsBridge', 'SetWeapon', weapon);
        }
    }, [isLoaded, unityInitialized, spec]);

    useEffect(() => {
        if (isLoaded) {
            const { character, weapon, back_swag } = spec;
            if (displayedSpec.current.weapon !== weapon) {
                window.unity.SendMessage('JsBridge', 'SetWeapon', weapon);
                window.unity.SendMessage('JsBridge', 'SetRotation', 'Right');
            }

            if (displayedSpec.current.back_swag !== back_swag) {
                window.unity.SendMessage('JsBridge', 'SetBackpack', back_swag);
                window.unity.SendMessage('JsBridge', 'SetRotation', 'Back');
            }

            if (displayedSpec.current.character !== character) {
                window.unity.SendMessage('JsBridge', 'SetCharacter', character);
                window.unity.SendMessage('JsBridge', 'SetRotation', 'Front');
            }

            displayedSpec.current = spec;
        }
    }, [spec, isLoaded]);

    return (
        <div className='CharacterViewer'>
            {!isLoaded && (
                <div className='CharacterViewerLoadingContent'>
                    <Loader size='large' />
                    <div className='CharacterViewerLoadingContent__text'>
                        Loading Warrior...
                    </div>
                </div>
            )}
            <canvas
                id='character-viewer'
                ref={canvasRef}
                width={width * 2}
                height={height * 2}
                style={{
                    width: width,
                    height: height,
                    background: '#381C73',
                    opacity: isLoaded ? 1 : 0,
                }}
            />
        </div>
    );
};

export default CharacterViewer;
